import { indexStore, IndexState } from './modules/index'
import { globalStore, GlobalState } from './modules/global'
import { userStore, UserState } from './modules/user'
import { commonStore, CommonState } from './modules/common'
import { classroomStore, ClassroomState } from './modules/classroom'
import { courseStore, CourseState } from './modules/course'
import { certificationStore, CertificationState } from './modules/certification'
import { examState, examStore } from './modules/exam'
import { TrainerState, trainerStore } from './modules/trainerTeam'
import { NewsState, newsStore } from './modules/news'
import { InvitationState, invitationStore } from './modules/invitation'

const modules = {
  index: indexStore,
  global: globalStore,
  user: userStore,
  common: commonStore,
  classroom: classroomStore,
  course: courseStore,
  certification: certificationStore,
  exam: examStore,
  trainerTeam: trainerStore,
  news: newsStore,
  invitation: invitationStore
}

export interface RootState {
  global: GlobalState
  index: IndexState
  user: UserState
  common: CommonState
  classroom: ClassroomState
  course: CourseState
  certification: CertificationState
  exam: examState
  trainerTeam: TrainerState
  news: NewsState
  invitation: InvitationState
}

export {
  modules
}
